import { render, staticRenderFns } from "./user_grzx.vue?vue&type=template&id=e38a580a&scoped=true"
import script from "./user_grzx.vue?vue&type=script&lang=js"
export * from "./user_grzx.vue?vue&type=script&lang=js"
import style0 from "./user_grzx.vue?vue&type=style&index=0&id=e38a580a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38a580a",
  null
  
)

export default component.exports